var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"tutorial-container",style:({ zIndex: _vm.defaultZindex + _vm.zIndex }),on:{"click":function($event){$event.stopPropagation();return _vm.bindCatch.apply(null, arguments)},"touchmove":_vm.bindTouchMove}},[_c('div',{staticClass:"tip-circle",class:{
      'circle-top': _vm.direction == 'bottom',
      'circle-bottom': _vm.direction == 'top'
    },style:({
      left: _vm.position.x + 'px',
      top: _vm.position.y + 'px',
      opacity: _vm.showTutorail ? 1 : 0
    })},[_c('div',{ref:"tipcontent",staticClass:"tip-content",class:{
        'content-top': _vm.direction == 'top',
        'content-bottom': _vm.direction == 'bottom'
      },style:({
        paddingLeft: _vm.image ? _vm.imageObj.width + _vm.imageObj.left + 'px' : '14px',
        transform: 'translate(' + _vm.textTransform + '%, 0%)'
      })},[_c('div',{staticClass:"tip-text",style:({ textAlign: _vm.options.textAlign || 'left' }),domProps:{"innerHTML":_vm._s(_vm.options.text || '')}}),(_vm.image)?_c('img',{staticClass:"tip-image",style:({
          left: _vm.imageObj.left + 'px',
          width: _vm.imageObj.width + 'px',
          height: _vm.imageObj.height + 'px'
        }),attrs:{"src":"https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8e599953f9d7f084fefb1ea9c9769a3c.png","alt":""}}):_vm._e()])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }